import { NgModule } from '@angular/core';
import { CountsByKeyPipe } from './counts-by-key.pipe';

@NgModule({
    declarations: [CountsByKeyPipe],
    exports: [CountsByKeyPipe],
})
export class CountsByKeyPipeModule {}
